export const faqs = [
  {
    question: '韩漫在线是免费的吗？',
    answer: '是的，韩漫在线是一个完全免费的韩国漫画在线阅读平台。我们提供高清画质的漫画内容，您无需支付任何费用即可畅读所有作品。',
  },
  {
    question: '什么是下拉式漫画阅读体验？',
    answer: '下拉式阅读是指垂直滚动浏览漫画内容，无需翻页。这种方式特别适合在手机或电脑上连续阅读，画面流畅自然，给您最舒适的韩漫阅读体验。',
  },
  {
    question: '韩漫在线的漫画多久更新一次？',
    answer: '我们的漫画作品保持与韩国原版同步更新，通常每周更新1-2话。热门连载作品每日都有更新，您可以通过收藏功能获取更新提醒。',
  },
  {
    question: '支持哪些设备阅读漫画？',
    answer: '韩漫在线完美支持PC电脑、平板和手机端的阅读。我们的自适应设计确保在不同屏幕尺寸上都能获得最佳的漫画阅读体验。',
  },
  {
    question: '如何找到我喜欢的漫画类型？',
    answer: '您可以通过首页的分类导航选择感兴趣的漫画类型，包括恋爱、奇幻、动作、剧情、喜剧、悬疑等。也可以在搜索框中直接搜索漫画名称或作者。',
  },
  {
    question: '漫画的画质如何？',
    answer: '所有漫画均提供高清画质，确保每一格的细节都清晰可见。我们使用先进的图片优化技术，在保证画质的同时提供快速的加载速度。',
  },
];

export const aboutStats = [
  { label: '入驻作者', value: '500+', icon: 'ri-user-star-line' },
  { label: '漫画作品', value: '12,000+', icon: 'ri-book-open-line' },
  { label: '累计读者', value: '800万+', icon: 'ri-user-heart-line' },
  { label: '日均阅读', value: '300万次', icon: 'ri-eye-line' },
];

export const milestones = [
  { year: '2018', title: '平台创立', description: '韩漫在线正式上线，致力于为中文读者带来优质的韩国漫画内容。' },
  { year: '2019', title: '内容扩展', description: '与韩国多家漫画平台达成合作，漫画库突破5000部，注册用户突破50万。' },
  { year: '2020', title: '技术升级', description: '推出下拉式阅读模式，优化移动端体验，获得App Store推荐。' },
  { year: '2021', title: '社区建设', description: '上线读者评论和收藏系统，建立韩漫爱好者社区，日活跃用户突破100万。' },
  { year: '2022', title: '品牌升级', description: '完成品牌视觉升级，与更多韩国顶级漫画家签约独家合作。' },
  { year: '2023', title: '高速增长', description: '月活跃用户突破500万，成为中文市场最大的韩漫阅读平台之一。' },
  { year: '2024', title: '全球布局', description: '开启海外华人市场服务，支持多语言阅读，继续引领韩漫阅读新体验。' },
];

export const contactInfo = {
  address: '北京市朝阳区望京SOHO T1座1206室',
  phone: '400-888-6666',
  email: 'hello@wxctif.com',
  wechat: 'manhuazx_kefu',
  workHours: '周一至周五 9:00 - 18:00',
};

export const cooperationTypes = [
  { title: '内容合作', description: '欢迎韩国漫画作者和出版社与我们合作，共同推广优质韩漫内容。我们提供专业的翻译和本地化服务。', icon: 'ri-pen-nib-line' },
  { title: '广告合作', description: '为品牌提供精准的韩漫读者群体投放渠道，包括首页Banner、插屏广告和原生内容植入等多种形式。', icon: 'ri-advertisement-line' },
  { title: 'IP授权', description: '平台热门漫画IP开放授权合作，涵盖周边商品开发、影视改编、游戏联动等多种商业形式。', icon: 'ri-copyright-line' },
  { title: '技术合作', description: '开放API接口，与第三方阅读器、内容聚合平台进行技术对接，共同扩大韩漫的影响力。', icon: 'ri-code-s-slash-line' },
];